import React, { Component } from "react";
import { connect } from "react-redux";

class Badge extends Component {
  render() {
    const { badgeValue } = this.props;
    return (
      <div className="badge">
        <img
          src={process.env.PUBLIC_URL + "/img/" + badgeValue + ".png"}
          alt={badgeValue}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  site: state.site,
});

export default connect(mapStateToProps, {})(Badge);
